import { Box, styled } from '@mui/material';
import { ultraMarine } from '../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  minWidth: 0,
  '& .content': {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    minWidth: 0,
  },
  '& .iconWrapper': {
    width: 28,
    height: 28,
    minWidth: 28,
    borderRadius: '50%',
    backgroundColor: ultraMarine[600],
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  '& .text': {
    color: ultraMarine[700],
    minWidth: 0,
  },
});

export default StyledBox;
